import { createClient } from 'contentful'
const client = createClient({
    space: process.env.CONTENTFUL_SPACE_ID,
    accessToken: process.env.CONTENTFUL_ACCESS_TOKEN,
    host: process.env.CONTENTFUL_HOST,
    environment: "redesign-phase-2",
    timeout: 30000,
    retryLimit: 10,
})

const DEFAULT_LOCALE_CODE = 'en-US'

const CONTENTFUL_LOCALE_MAPPINGS = {
    'English': {
        'United States': 'en-US',
        'Canada': 'en-CA',
        'United Kingdom': 'en-GB',
        'Ireland': 'en-GB'
    },
    'French': {
        'France': 'fr',
        'Canada': 'fr-CA',
        'Luxembourg': 'fr',
        'Switzerland': 'fr',
        'Belgium': 'fr'
    },
    'Dutch': {
        'Netherlands': 'nl',
        'Belgium': 'nl'
    },
    'German': {
        'Germany': 'de',
        'Austria': 'de',
        'Switzerland': 'de',
        'Belgium': 'de',
        'Liechtenstein': 'de'
    },
    'Spanish': {
        'Mexico': 'es-MX',
        'Spain': 'es-MX',
    },
    'Italian': {
        'Italy': 'it'
    }
}

const CONTENTFUL_LOCALE_MAPPINGS_BY_COUNTRY = {
    'United States': 'en-US',
    'Canada': 'en-CA',
    'United Kingdom': 'en-GB'
}

export async function getByContentType(content_type, locale, options = {}) {
    let initial = {
        'content_type': content_type,
        'locale': locale,
    }
    let query = {
        ...initial,
        ...options
    }

    return await client
        .getEntries(query)
        .then(result => {
            return result.items[0].fields
        })
}

export function determine_locale(language, country) {
    if (language in CONTENTFUL_LOCALE_MAPPINGS && country in CONTENTFUL_LOCALE_MAPPINGS[language]) {
        return CONTENTFUL_LOCALE_MAPPINGS[language][country];
    } else if (!(language in CONTENTFUL_LOCALE_MAPPINGS) && country in CONTENTFUL_LOCALE_MAPPINGS_BY_COUNTRY) {
        return CONTENTFUL_LOCALE_MAPPINGS_BY_COUNTRY[country]
    } else {
        return DEFAULT_LOCALE_CODE;
    }
}

